import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import 'leaflet/dist/leaflet.css'; // v3.10.1: CRITICAL — without this, maps render broken (tiles misplaced, controls invisible, popups unstyled)
import { logger } from './lib/logger';
import { initializeOfflineKernel } from './offline';

// Setup logger to suppress warnings
logger.setup();

// Log app version
logger.info('CoConnect v1.0.0');

// Initialize the durable offline kernel before React workflows begin issuing
// commands. Initialization failures are surfaced by the status/health layer and
// never cause destructive local database resets.
void initializeOfflineKernel();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
